import i18next from 'i18next';
import * as yup from 'yup';

const schema = yup.object().shape({
  phone_number: yup.string().required(() => i18next.t('validations.required')),
});

export default schema;
